const logos = {
  Fundera: 1,
};

const icons = {
  Twitter: 1,
  Facebook: 2,
  Instagram: 3,
};

const Constants = {
  logos,
  icons,
};

export default Constants;
